// 这个存放和业务相关的工具函数，可以引入vuex，也可以发起请求
import userStore from "@/store/modules/user";
import baseStore from "@/store/modules/base";
import app from "@/store/modules/app";
import store from "@/store";
import uploadImageHandler from "./editor";
import { splitThousands, emptyToLine } from "./common";
import appCode from "@common/src/utils/app-code";
import commonApp from "@common/src/store/modules/app";
import _ from "lodash-es";

export function formDownload(url, param) {
  let kyes = Object.keys(param);
  let paramArr = kyes.map(item => {
    return {
      name: item,
      value: _.isNil(param[item]) ? "" : param[item] // 剔除null  undefined 等无效字段
    };
  });
  paramArr.push({
    name: "userAuthToken",
    value: userStore.state.token
  });
  paramArr.push({
    name: "userLanguage",
    value: store.getters["common_app/severLanguage"]
  });
  var form = document.createElement("form");
  document.getElementsByTagName("body")[0].appendChild(form);
  form.setAttribute("style", "display:none");
  form.setAttribute("target", "_blank");
  form.setAttribute("method", "post");
  form.setAttribute("action", url);
  paramArr.forEach(item => {
    var input1 = document.createElement("input");
    input1.setAttribute("type", "hidden");
    input1.setAttribute("name", item.name);
    input1.setAttribute("value", item.value);
    form.appendChild(input1);
  });
  form.submit();
  form.remove();
}

export function editorUploadHandler(options) {
  new uploadImageHandler(options);
}

/**
 *金额添加货币符号
 * @param money 金额
 * @param split 是否千位分割
 * @returns 结果
 */
export function addCurrencySymbol(money, split = false) {
  return split
    ? `${baseStore.state.serverStateInfo.currencySymbol} ${splitThousands(emptyToLine(money))}`
    : `${baseStore.state.serverStateInfo.currencySymbol} ${emptyToLine(money)}`;
}

/**
 *金额添加货币单位 收款金额(元)
 * @param money 金额
 * @param split 是否千位分割
 * @param hasBrackets 货币单位是否有括号
 * @returns 结果
 */
export function addCurrencyUnit(money, split = false, hasBrackets = false) {
  return split
    ? hasBrackets
      ? `${splitThousands(emptyToLine(money))} (${baseStore.state.serverStateInfo.currencyUnit})`
      : splitThousands(emptyToLine(money)) + baseStore.state.serverStateInfo.currencyUnit
    : hasBrackets
    ? `${emptyToLine(money)} (${baseStore.state.serverStateInfo.currencyUnit})`
    : emptyToLine(money) + baseStore.state.serverStateInfo.currencyUnit;
}

/**
 * 当前国家是否符合提供的国家集合
 * @param {Array} 国家集合
 * @returns {Boolean} show
 */
export function showOfCountrys(countryArr = []) {
  return countryArr.includes(app.state.country);
}

/**
 * @param {Array} 权限控制按钮级别
 * @returns {Boolean} show
 */
export function permit(permisKey) {
  if (_.isString(permisKey)) {
    return userStore.state.permissionList.includes(permisKey);
  } else {
    return permisKey.some(key => {
      return userStore.state.permissionList.includes(key);
    });
  }
}

/**
 * @param {Sting} 权限控制应用级别
 * @returns {Boolean} show
 */
// 使用类型别名，表示允许的应用代码值
export function permitApp(appName) {
  if (_.isString(appName)) {
    return appName === appCode;
  } else {
    return appName.includes(appCode);
  }
}

/**
 * @param {Sting} 权限控制国家级别
 * @returns {Boolean} show
 */
export function permitCountry(countryName) {
  if (_.isString(countryName)) {
    return countryName === commonApp.state.country;
  } else {
    return countryName.includes(commonApp.state.country);
  }
}

/**
 *
 * @param code
 */
export function isCustomPlateCode(code: string): boolean {
  const first = code.slice(0, 1);
  return !app.state.plateCodeProvinceList.includes(first);
}

/**
 * 是否是精友的数据
 * @param modelCode 车型code
 */
export function isJingyouvehicleData(modelCode: string) {
  return modelCode && (modelCode.includes("AP_") || modelCode.includes("OTHER"));
}
